<template>
	<div class="homeDiv">
		<!-- banner -->
		<div class="banner">
			<el-carousel :interval="5000" :autoplay='flag' @mouseenter.native='delHandleMouseEnter'
				@mouseleave.native='delHandleMouseLeave'>
				<el-carousel-item>
					<div>
						<img src="../../assets/img/banner16.png" alt="">
						<div>
							<div class="bt">
								<!-- 上海一线品质网站建设服务商 -->
								智慧城市
								<br>
							</div>
							<div class="js">
								<p>通过物联网、云计算、大数据和空间地理信息集成的应用，使城市管理信息化和数字化。</p>
								<!-- <p></p> -->
								<p>智慧城市管理提高资源利用率，为政府赋能，优化城市管理和改善人民生活。</p>
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item>
					<div>
						<img src="../../assets/img/banner01.png" alt="">
						<div>
							<div class="bt">
								智慧工地
								<br>
								<!-- 品牌数字化策略——赋能企业影响力提升 -->
							</div>
							<div class="js">
								<p>
									运用信息化手段，通过三维设计平台对工程项目进行精确设计和施工模拟。
								</p>
								<p>围绕施工过程管理，建立互联协同、智能生产和科学管理的施工项目信息化生态圈。</p>
								<p>
									实现工程施工可视化智能管理，以提高工程管理信息化水平，从而逐步实现绿色建造和生态建造。
								</p>
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item>
					<div>
						<img src="../../assets/img/banner8.jpg" alt="">
						<div>
							<div class="bt">
								<!-- 上海一线品质网站建设服务商 -->
								智慧建造
								<br>
							</div>
							<div class="js">
								<p>
									BIM技术是智慧建造的基石，推动了工程建设信息化发展，保障工程建设质量安全，提升了投资效益。
								</p>
								<p>
									智慧建造技术是工程建设的项目规划设计、现场施工、统计分析和运营维护等全过程的集成应用。
								</p>
								<p>
									智慧建造实现工程建设项目全生命周期的数据共享和信息化管理，实现了由“制造”到“智造”的跨越。
								</p>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="homeMain">
			<!-- 产品中心 -->
			<div class="homeProduct">
				<div class="homeTitle">
					<div class="homeTitleText">产品中心</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="homeProductmain">
					<div class="homeProductmainChild">
						<!-- for循环开始 -->
						<div class="homeProductItem" @click="routerPointTo('caseMainConChildPro1')">
							<!-- 图片 -->
							<div class="homeProductItemImg">
								<img src="../../assets/产品中心/sce1.png" alt="">
								<!-- 这里是鼠标放上去图片效果 -->
								<!-- <div class="homeProductItemHover">
									<div class="hoverBorderDiv">
										<div>
											<p>
												国际创新协同区是多圈层融合的潜力区，毗邻大学城与特殊综合保税围网区，是产城深度融合的功能片区。空间上，分为一环带总部湾（0.5平方公里区域）、二环公园带（0.8平方公里区域）、顶尖科学家社区（2.5平方公里区域）、科技创新城社区（3.2平方公里区域）。国际创新协同区规划面积6.8平方公里，规划总人口5.4万，开发体量703万平方米。
											</p>
										</div>
									</div>
								</div> -->
							</div>
							<!-- 文字 -->
							<div class="homeProductItemText">
								<h4>BIM协同管理平台</h4>
								<!-- <p>
									国际创新协同区是多圈层融合的潜力区，毗邻大学城与特殊综合保税围网区，是产城深度融合的功能片区。空间上，分为一环带总部湾（0.5平方公里区域）、二环公园带（0.8平方公里区域）、顶尖科学家社区（2.5平方公里区域）、科技创新城社区（3.2平方公里区域）。国际创新协同区规划面积6.8平方公里，规划总人口5.4万，开发体量703万平方米。
								</p> -->
							</div>
						</div>
						<div class="homeProductItem" @click="routerPointTo('caseMainConChildPro4')">
							<!-- 图片 -->
							<div class="homeProductItemImg">
								<img src="../../assets/产品中心/bimboot1.png" alt="">
								<!-- 这里是鼠标放上去图片效果 -->
								<!-- <div class="homeProductItemHover">
									<div class="hoverBorderDiv">
										<div>
											<p>
												国际创新协同区是多圈层融合的潜力区，毗邻大学城与特殊综合保税围网区，是产城深度融合的功能片区。空间上，分为一环带总部湾（0.5平方公里区域）、二环公园带（0.8平方公里区域）、顶尖科学家社区（2.5平方公里区域）、科技创新城社区（3.2平方公里区域）。国际创新协同区规划面积6.8平方公里，规划总人口5.4万，开发体量703万平方米。
											</p>
										</div>
									</div>
								</div> -->
							</div>
							<!-- 文字 -->

							<div class="homeProductItemText">
								<h4>国际协同创新区平台</h4>
								<!-- <p>
									国际创新协同区是多圈层融合的潜力区，毗邻大学城与特殊综合保税围网区，是产城深度融合的功能片区。空间上，分为一环带总部湾（0.5平方公里区域）、二环公园带（0.8平方公里区域）、顶尖科学家社区（2.5平方公里区域）、科技创新城社区（3.2平方公里区域）。国际创新协同区规划面积6.8平方公里，规划总人口5.4万，开发体量703万平方米。
								</p> -->
							</div>
						</div>
					</div>
					<div class="homeProductmainChild">
						<div class="homeProductItem" @click="routerPointTo('caseMainConChildPro2')">
							<!-- 图片 -->
							<div class="homeProductItemImg">
								<img src="@/assets/img/pro-ctsw.png" alt="">
								<!-- <div class="homeProductItemHover">
									<div class="hoverBorderDiv">
										<div>
											<p>
												水务建设一网管是BIM技术应用思路的实施载体，借助水务建设一网管进行项目管理，可以切实缩短工作流程，提高工作效率和管理水平，不仅能够将公司的管理结构进行规范化，也可以对每名项目管理人员进行合理的工作安排，实现对水务建设上的所有数据信息的管控。同时，公司和项目领导可以实时查询项目的进展情况，了解项目实时的施工进度，对原始单据数据信息能够更好地保存。系统包含公司级和项目级两个管理维度，公司级主要包含企业日常的新闻管理、项目管理、合同管理、计划管理、党建管理、会议管理、任务管理、文档管理、模型管理等。项目级是围绕公司开展的项目维度来进行管理的主要包含项目信息管理、人员信息管理、文档管理、项目新闻管理、问题管理、安全管理、进度管理、BIM模型管理、设计图纸管理、进度管理等。
											</p>
										</div>
									</div>
								</div> -->
							</div>
							<!-- 文字 -->
							<div class="homeProductItemText">
								<h4>一网管协同平台</h4>
								<!-- <p>水务建设一网管是BIM技术应用思路的实施载体，借助水务建设一网管进行项目管理，可以切实缩短工作流程，提高工作效率和管理水平，不仅能够将公司的管理结构进行规范化，也可以对每名项目管理人员进行合理的工作安排，实现对水务建设上的所有数据信息的管控。同时，公司和项目领导可以实时查询项目的进展情况，了解项目实时的施工进度，对原始单据数据信息能够更好地保存。系统包含公司级和项目级两个管理维度，公司级主要包含企业日常的新闻管理、项目管理、合同管理、计划管理、党建管理、会议管理、任务管理、文档管理、模型管理等。项目级是围绕公司开展的项目维度来进行管理的主要包含项目信息管理、人员信息管理、文档管理、项目新闻管理、问题管理、安全管理、进度管理、BIM模型管理、设计图纸管理、进度管理等。
								</p> -->
							</div>
						</div>
						<div class="homeProductItem" @click="routerPointTo('caseMainConChildPro3')">
							<!-- 图片 -->
							<div class="homeProductItemImg">
								<img src="@/assets/img/pro-zd.png" alt="">
								<!-- <div class="homeProductItemHover">
									<div class="hoverBorderDiv">
										<div>
											<p>
												香港置地集团主要涉及采购物料、场外管理（订单、要货单、运单、在途）、场内管理（进场、验收、试件检测、HU标签的信息管理、场内库存、安装、退货），以及物料流程追溯（PC、小程序），物流相关主数据维护（施工阶段主数据、项目物料BOM主数据、物料地图轨迹查询、物流智能调度（优选功能）、供应商分级管理（优选功能）等
											</p>
										</div>
									</div>
								</div> -->
							</div>
							<!-- 文字 -->
							<div class="homeProductItemText">
								<h4>物流追溯平台</h4>
								<!-- <p>香港置地集团主要涉及采购物料、场外管理（订单、要货单、运单、在途）、场内管理（进场、验收、试件检测、HU标签的信息管理、场内库存、安装、退货），以及物料流程追溯（PC、小程序），物流相关主数据维护（施工阶段主数据、项目物料BOM主数据、物料地图轨迹查询、物流智能调度（优选功能）、供应商分级管理（优选功能）等
								</p> -->
							</div>
						</div>
					</div>
					<!-- for循环结束 -->
					<!-- 按钮 -->
					<div class="homeBtn">
						<router-link to="/product" class="more-btn">查看更多</router-link>
					</div>
				</div>
			</div>
			<!-- 图片数字描述 -->
			<div class="numDes">
				<div class="numDesAction">
				</div>
				<div class="numDesActionItem">
					<div class="homeTitle">
						<div class="homeTitleText">让煜豆演绎数字化之美</div>
						<div class="homeTitleLine"></div>
					</div>
					<div class="numDesActionItemMain">
						<ul>
							<li>
								<div class="numDesIcon">
									<img src="../../assets/img/data1.png" alt="">
								</div>
								<div class="numDesCont">
									<h3>
										<b class="counter">99</b>
										个
										<sup>+</sup>
									</h3>
									<p>客户信赖之选</p>
								</div>
							</li>
							<li>
								<div class="numDesIcon">
									<img src="../../assets/img/data2.png" alt="">
								</div>
								<div class="numDesCont">
									<h3>
										<b class="counter">200</b>
										亿
										<sup>+</sup>
									</h3>
									<p>服务品牌市值</p>
								</div>
							</li>
							<li>
								<div class="numDesIcon">
									<img src="../../assets/img/data3.png" alt="">
								</div>
								<div class="numDesCont">
									<h3>
										<b class="counter">36</b>
										个
										<sup>+</sup>
									</h3>
									<p>自主研发版权</p>
								</div>
							</li>
							<li>
								<div class="numDesIcon">
									<img src="../../assets/img/data4.png" alt="">
								</div>
								<div class="numDesCont">
									<h3>
										<b class="counter">80</b>
										w
										<sup>+</sup>
									</h3>
									<p>单一标杆客户的用户体量</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!-- 成功案例 -->
			<div class="homeSuccess">
				<div class="homeTitle">
					<div class="homeTitleText">成功案例</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="homeSuccessMain">
					<div class="homeSuccessMainChild">
						<!-- for循环开始 -->
						<div class="homeSuccessItem" @click="routerPointTo('caseMainConChild0')">
							<div>
								<!-- <img src="../../assets/img/1.jpg" alt=""> -->
								<img src="../../assets/图片文件夹/图片2.jpg" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>张江科学之门项目</h3>
									<p></p>
								</div>
							</div>
							<div>
								<!-- <img src="../../assets/img/2.jpg" alt=""> -->
								<img src="../../assets/图片文件夹/图片3.png" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>金融湾项目</h3>
									<p></p>
								</div>
							</div>
							<div>
								<!-- <img src="../../assets/img/3.png" alt=""> -->
								<img src="../../assets/图片文件夹/图片4.png" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>集成电路产业园</h3>
									<p></p>
								</div>
							</div>
							<div>
								<!-- <img src="../../assets/img/4.png" alt=""> -->
								<img src="../../assets/图片文件夹/图片5.jpg" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>金桥17B-06地块商办项目</h3>
									<p></p>
								</div>
							</div>

							<div>
								<!-- <img src="../../assets/img/6.png" alt=""> -->
								<img src="../../assets/图片文件夹/图片7.jpg" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>综合管廊运维平台</h3>
									<p></p>
								</div>
							</div>
							<div>
								<!-- <img src="../../assets/img/5.png" alt=""> -->
								<img src="../../assets/图片文件夹/图片6.png" alt="">
								<!-- <div class="homeSuccessName">BIM实现精细化管理</div> -->
								<div class="homeSuccessHover">
									<h3>徐汇滨江项目</h3>
									<p></p>
								</div>
							</div>

						</div>
						<!-- for循环结束 -->
					</div>
					<!-- 按钮 -->
					<div class="homeBtn">
						<router-link to="/case" class="more-btn">查看更多</router-link>
					</div>
				</div>
			</div>
			<!-- 合作服务流程 -->
			<div class="process">
				<div class="homeTitle">
					<div class="homeTitleText">项目开发流程</div>
					<div class="homeTitleLine"></div>
				</div>
				<ul class="processUl">
					<li>
						1.需求分析
						<i class="el-icon-caret-bottom"></i>
					</li>
					<li>
						3.计划任务
						<i class="el-icon-caret-bottom"></i>
					</li>
					<li>

						2.原型设计
						<i class="el-icon-caret-top"></i>
					</li>
					<li>
						5.测试优化
						<i class="el-icon-caret-top"></i>
					</li>
					<li>

						4.系统开发
						<i class="el-icon-caret-bottom"></i>
					</li>
					<li>
						6.上线运维
						<i class="el-icon-caret-bottom"></i>
					</li>
				</ul>
			</div>
			<!-- 新闻动态 -->
			<div class="newsInfo">
				<div class="homeTitle">
					<div class="homeTitleText">新闻动态</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="newsInfoMain">
					<div class="newsInfoMainChild">
						<div class="newsInfoMainChildDiv">
							<!-- for循环开始 -->
							<!-- <div class="newsInfoConStar" @click="routerPointTo('newsListConItem2')"> -->
							<div class="newsInfoConStar">
								<div class="border_top"></div>
								<div class="border_right"></div>
								<div class="border_bottom"></div>
								<div class="border_left"></div>
								<div class="newsInfoConStarT">
									<img src="../../assets/图片文件夹/1678693937569588.png" alt="" @click="hendMenu">
								</div>
								<div class="newsInfoConStarM">
									<span>
										09/05
										<br>
										<font>2022</font>
									</span>
									<h4>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司领导在上海绿地万豪酒店参加了中国数字建筑峰会，把会议的中心思想传递给员工，提升员工的工作意识，更好地对接与客户的服务。
									</h4>
								</div>
								<div class="newsInfoConStarF">
									<p>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过此次会议，我们将进一步提升公司的经营理念，从而汇聚更多优势资源，打造更高端、更专注的软件开发平台，共谋软件开发行业美好愿景。
									</p>
								</div>
							</div>
							<div class="newsInfoConStar">
								<div class="border_top"></div>
								<div class="border_right"></div>
								<div class="border_bottom"></div>
								<div class="border_left"></div>
								<div class="newsInfoConStarT">
									<img src="../../assets/图片文件夹/微信图片_20230327102138.jpg" alt="" @click="changeInfo">
								</div>
								<div class="newsInfoConStarM">
									<span>
										03/2
										<br>
										<font>2023</font>
									</span>
									<h4>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了调节工作压力，营造激情、责任和快乐的工作氛围，从而让大家更好地投入到接下来的工作中。公司特别组织了“激扬青春，向健康出发。
									</h4>
								</div>
								<div class="newsInfoConStarF">
									<p>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2023年3月2日星期四下午，在东亚体育文化中活动正式拉开序幕。公司组织了羽毛球比赛，活动场面既激情如火又温馨和谐。
									</p>
								</div>
							</div>
							<!-- for循环结束 -->
						</div>
					</div>
					<!-- 按钮 -->
					<div class="homeBtn">
						<!-- <router-link :to="{path:'/about',query:{pointIdName:'newsList'}}" class="more-btn">查看更多
						</router-link> -->
						<span class="more-btn">查看更多</span>
					</div>
				</div>
			</div>
		</div>
		<Newsandtrends ref="newsandtrends" @refreshtreeTo="refreshtreeTo"></Newsandtrends>
		<FirstNumber ref="firstNumber" @refreshtreeTo="refreshtreeTo"></FirstNumber>
	</div>
</template>
<script>
	import Newsandtrends from '../../components/Newsandtrends.vue'
	import FirstNumber from '../../components/FirstNumber.vue'
	export default {
		components: { Newsandtrends, FirstNumber },
		data() {
			return {
				flag: true, //自动播放
			}
		},
		created() {
			document.documentElement.scrollTop = 0;
		},
		methods: {
			// 鼠标移入停止自动切换
			delHandleMouseEnter() {
				this.$nextTick(() => {
					this.flag = false
				})
			},
			// 鼠标移除开始自动切换
			delHandleMouseLeave() {
				this.$nextTick(() => {
					this.flag = true
				})
			},
			// 
			// 跳转锚点
			routerPointTo(pointIdName) {
				if (pointIdName == 'caseMainConChild0') {
					this.$router.push({
						path: '/case',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				} else if (pointIdName == 'caseMainConChildPro1' || pointIdName == 'caseMainConChildPro2' || pointIdName ==
					'caseMainConChildPro3' || pointIdName == 'caseMainConChildPro4') {
					this.$router.push({
						path: '/product',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				}
			},
			refreshtreeTo() { },
			changeInfo() {
				this.$refs.newsandtrends.show()
			},
			hendMenu() {
				this.$refs.firstNumber.show()
			}
		},
	}
</script>
<style scoped lang="scss">
	.homeDiv {
		width: 100%;
	}

	.banner {
		width: 100%;
		margin-bottom: 45px;

		img {
			width: 100%;
			height: 100%;
		}

	}

	.homeMain {
		width: 100%;
	}

	.homeTitle {
		width: 100%;
		text-align: center;
		margin: 0 auto;
		margin-bottom: 35px;
	}

	.homeTitleText {
		height: 45px;
		font-size: 31px;
		color: #000;
		font-weight: 500;
		// padding: 60px 0 8px 0;
		padding: 30px 0 8px 0;
	}

	.homeTitleLine {
		width: 64px;
		height: 3px;
		background: #006fff;
		margin: 0 auto;
	}

	.homeProduct {
		width: 65%;
		margin: 0 auto;
	}

	// homeProductmain开始**********************
	.homeProductmain {
		width: 100%;
	}

	.homeProductmainChild {
		margin-top: 40px;
		width: 100%;
		display: flex;
		justify-content: space-around;
		align-items: stretch;
		flex-direction: row-reverse;
		flex-wrap: nowrap;
		align-content: space-around;
	}

	.homeProductItem {
		// width: 25%;
		height: 290px;
		// height: 240px;
		// width: 23%;
		// width: 30%;
		width: 45%;
		border-radius: 10px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
		overflow: hidden;
		margin-left: 0 1%;
		padding-bottom: 4px;
	}

	.homeProductItemImg {
		height: 75%;
		// height: 70%;
		width: 100%;
		position: relative;
		cursor: pointer;
	}

	.homeProductItemImg>img {
		width: 100%;
		/* height: 100%; */
		height: 240px;
	}

	.homeProductItemImg>div {
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(13, 157, 255, .8);
		opacity: 0;
		width: 100%;
		height: 100%;
		transition: all 0.3s ease-out;
	}

	.hoverBorderDiv {
		text-align: center;
		width: 94%;
		height: 90%;
		margin-top: 3%;
		margin-left: 3%;
		transition: ease-in .3s;
		background: linear-gradient(0, rgba(255, 255, 255, 0.8) 1px, rgba(255, 255, 255, 0.8) 1px) no-repeat,
			linear-gradient(-90deg, rgba(255, 255, 255, 0.8) 1px, rgba(255, 255, 255, 0.8) 1px) no-repeat,
			linear-gradient(-180deg, rgba(255, 255, 255, 0.8) 1px, rgba(255, 255, 255, 0.8) 1px) no-repeat,
			linear-gradient(-270deg, rgba(255, 255, 255, 0.8) 1px, rgba(255, 255, 255, 0.8) 1px) no-repeat;
		background-size: 0 1px, 1px 0, 0 1px, 1px 0;
		background-position: left top, right top, right bottom, left bottom;

		div {
			vertical-align: middle;

			img {
				height: auto;
				max-height: none;
			}

			p {
				color: #fff;
				font-size: 14px;
				line-height: 25px;
				padding: 35px 40px 0 40px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 5;
				text-align: left;
			}
		}
	}

	.homeProductItemImg:hover div {
		opacity: 1;
	}

	.homeProductItemImg:hover .hoverBorderDiv {
		background-size: 100% 1px, 1px 100%, 100% 1px, 1px 100%;
	}


	.homeProductItemText {
		width: 25%;
		width: 100%;
	}

	.homeProductItemText>h4,
	.homeProductItemText>p {
		margin: 0;
		padding: 0;
		width: 90%;
		margin: 0 auto;
		// 禁止文字选中
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.homeProductItemText>h4 {
		// height: 28px;
		// line-height: 28px;
		// margin-top: 3px;
		// margin-bottom: 1px;
		// color: #333;
		height: 28px;
		line-height: 28px;
		margin-top: 36px;
		margin-bottom: 2px;
		color: #333;
		text-align: center;
	}

	.homeProductItemText>p {
		font-size: 12px;
		color: #666;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2; // 想要超出三行显示 就把这里改成3就好了
	}

	// homeProductmain结束**********************
	// homeBtn开始**********************
	.homeBtn {
		width: 100%;
		text-align: center;
		// margin: 48px 0 65px 0;
		margin: 48px 0 80px 0;
	}

	.more-btn {
		text-decoration: none;
		position: relative;
		display: inline-block;
		padding: 10px 35px;
		font-size: 14px;
		color: #fff;
		background-color: #409EFF;
		border-radius: 20px;
	}

	.more-btn::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		border: 1.5px solid #409EFF;
		top: 50%;
		left: 50%;
		padding: 5px;
		transform: translate(-50%, -50%);
		border-radius: inherit;
		border-radius: 30px;
		-webkit-animation: actif-btn-wave 1s infinite ease-out;
		animation: actif-btn-wave 1s infinite ease-out;
	}

	.more-btn:hover {
		-webkit-animation: anim-moema-1 0.4s forwards;
		animation: anim-moema-1 0.4s forwards;
	}

	@keyframes actif-btn-wave {
		0% {
			-webkit-transform: translate(-50%, -50%) scale(1);
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
			-webkit-transform-origin: center;
			transform-origin: center;
		}

		100% {
			-webkit-transform: translate(-50%, -50%) scale(1.2);
			transform: translate(-50%, -50%) scale(1.2);
			opacity: 0;
			-webkit-transform-origin: center;
			transform-origin: center;
		}
	}

	@keyframes anim-moema-1 {
		60% {
			-webkit-transform: scale3d(0.8, 0.8, 1);
			transform: scale3d(0.8, 0.8, 1);
		}

		85% {
			-webkit-transform: scale3d(1.1, 1.1, 1);
			transform: scale3d(1.1, 1.1, 1);
		}

		100% {
			-webkit-transform: scale3d(1, 1, 1);
			transform: scale3d(1, 1, 1);
		}
	}

	// homeBtn结束**********************
	// numDes开始**********************
	.numDes {
		width: 100%;
		// height: 320px;
		// height: 350px;
		height: 400px;
		position: relative;
		margin-bottom: 45px;
	}

	.numDesAction {
		width: 100%;
		height: 100%;
		position: relative;
		background-image: url(../../assets/img/lines.jpg);
		background-repeat: no-repeat;
		background-size: cover;
	}

	.numDesAction::before {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		content: "";
		opacity: 0.9;
		background: #2889E4;
		// background: #409EFF;
		// background: rgba(82, 160, 232, 1);
	}

	.numDesActionItem {
		position: absolute;
		top: 15%;
		left: 17.5%;
		width: 65%;
		height: 70%;
		// background: red;
	}

	.numDesActionItem .homeTitleText {
		padding-top: 10px;
		color: #fff;
	}

	.numDesActionItem .homeTitleLine {
		background: #fff;
	}

	.numDesActionItemMain {
		width: 100%;
		height: 50%;
		margin-top: 5%;
		// background: papayawhip;
	}

	.numDesActionItemMain>ul {
		width: 100%;
		height: 100%;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-items: center;
		align-items: center;
	}

	.numDesActionItemMain>ul>li {
		width: 25%;
		position: relative;
		display: flex;
		flex-direction: row;
		color: #fff;
		justify-content: center;
	}

	.numDesActionItemMain>ul>li::before {
		position: absolute;
		content: "";
		width: 0.05rem;
		height: 2.5rem;
		background-color: #e6e6e6;
		opacity: 0.8;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
	}

	.numDesActionItemMain>ul>li:last-child::before {
		display: none;
	}

	.numDesIcon,
	.numDesCont {
		height: 100%;
	}

	.numDesIcon {
		width: 20%;
	}

	.numDesIcon>img {
		width: 100%;
		height: 100%;
	}

	.numDesCont {
		width: 45%;
		margin-left: 25px;
	}

	.numDesCont>h3 {
		font-weight: bold;
		font-size: 14px;
	}

	.numDesCont>h3 b {
		// font-size: 32px;
		font-size: 34px;
	}

	.numDesCont>h3 sup {
		font-weight: 400;
		font-size: 32px;
		display: inline-block;
		transform: translateY(-4px);
	}

	.numDesCont p {
		margin-top: 2px;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1; // 想要超出三行显示 就把这里改成3就好了
	}

	// numDes结束**********************


	// homeSuccess开始**********************
	.homeSuccess {
		width: 65%;
		margin: 0 auto;
	}

	.homeSuccessMainChild {}

	.homeSuccessItem {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.homeSuccessItem>div {
		width: 31%;
		position: relative;
		// height: 220px;
		height: 230px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
		margin: 0 0.875%;
		margin-bottom: 20px;
	}

	.homeSuccessItem>div>img {
		width: 100%;
		height: 100%;
	}

	.homeSuccessName {
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		height: 45px;
		line-height: 45px;
		background: rgba(13, 157, 255, .8);
		color: #fff;
		text-align: center;
		font-size: 16px;
	}

	.homeSuccessHover {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 50%;
		left: 0;
		background: rgba(13, 157, 255, .8);
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
		opacity: 0;
		transition: all 0.4s cubic-bezier(.4, 0, .2, 1);

		h3 {
			font-size: 20px;
			font-weight: normal;
			text-align: center;
			padding: 0 30px 0 30px;
		}

		p {
			font-size: 14px;
			line-height: 22px;
			padding: 20px 30px 0 30px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2; // 想要超出三行显示 就把这里改成3就好了
		}
	}

	.homeSuccessItem>div:hover .homeSuccessHover {
		top: 0%;
		opacity: 1;
		cursor: pointer;
	}

	.homeSuccessItem>div:hover .homeSuccessName {
		display: none;
	}

	// homeSuccess结束**********************
	// process开始**********************
	.process {
		width: 100%;
		height: 400px;
		position: relative;
		margin-bottom: 45px;
		background-image: url(../../assets/img/process.jpg);
		background-repeat: no-repeat;
		// background-size: cover;
		background-size: 100% 100%;

		.homeTitleText {
			color: #fff;
			padding-top: 20px;
		}

		.homeTitleLine {
			background: #fff;
		}

		.processUl {
			width: 65%;
			margin: 0 auto;
			height: 50%;
			list-style: none;
			position: relative;

			li {
				position: absolute;
				// width: 150px;
				width: 10.2%;
				height: 35px;
				text-align: center;
				line-height: 35px;
				background: #5CB5F4;
				color: #fff;
				border-radius: 5px;
				font-size: 14px;

				i {
					position: absolute;
					left: 50%;
					bottom: -13px;
					line-height: 20px;
					color: #5CB5F4;
					width: 20px;
					margin-left: -10px;
					font-size: 24px;
				}

				i.el-icon-caret-top {
					top: -13px;
				}
			}

		}
	}

	.processUl li:nth-child(1) {
		left: -2%;
		top: -31px;
	}

	.processUl li:nth-child(2) {
		left: 29%;
		top: -30px;
	}

	.processUl li:nth-child(3) {
		left: 20%;
		bottom: -55px;
	}

	.processUl li:nth-child(4) {
		right: 16%;
		bottom: -55px;
	}

	.processUl li:nth-child(5) {
		right: 23%;
		top: -30px;
	}

	.processUl li:nth-child(6) {
		right: -1%;
		top: -30px;
	}

	// process结束**********************
	// newsInfo开始**********************
	.newsInfo {
		width: 65%;
		margin: 0 auto;

		.newsInfoMainChild {
			width: 100%;

			.newsInfoMainChildDiv {
				padding: 0 20px;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
				margin-bottom: 18px;

				.newsInfoConStar {
					width: 45%;
					padding: 15px;
					position: relative;
					// cursor: pointer;

					.newsInfoConStarT {
						// height: 55%;
						height: 240px;
						border-radius: 10px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.newsInfoConStarM {
						padding: 18px 0 0 0px;
						display: flex;
						flex-direction: row;
						justify-content: space-between;

						span {
							font-size: 16px;
							// width: 54px;
							width: 10%;
							height: 44px;
							padding-top: 10px;
							text-align: center;
							display: block;
							float: left;
							color: #333;
							background: #f0f2f5;
							border: 1px #e2e3e8 solid;
							border-radius: 10px;

							font {
								font-size: 12px;
							}
						}

						h4 {
							color: #333;
							font-size: 14px;
							font-weight: normal;
							line-height: 22px;
							width: 85%;
							float: right;
							padding: 3px 0 9px 0;
							border-bottom: 1px #e2e3e8 solid;
							height: 45px;
							// 超过2行...省略
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2; // 想要超出三行显示 就把这里改成3就好了
						}
					}

					.newsInfoConStarF {
						text-align: left;
						font-size: 12px;
						line-height: 24px;
						color: #888;
						padding: 16px 12px 0 0px;
						// height: 80px;

						p {
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 3; // 想要超出三行显示 就把这里改成3就好了
						}
					}
				}
			}
		}
	}

	.newsInfoConStar .border_top,
	.newsInfoConStar .border_right,
	.newsInfoConStar .border_bottom,
	.newsInfoConStar .border_left {
		-webkit-transition: all .4s ease;
		-moz-transition: all .4s ease;
		-ms-transition: all .4s ease;
		transition: all .4s ease;
	}

	.newsInfoConStar .border_top,
	.newsInfoConStar .border_left {
		left: 0;
		top: 0;
		position: absolute;
		background: #5CB5F4;
	}

	.newsInfoConStar .border_right,
	// .newsInfoConStar .border_bottom{bottom:0;right:0; position:absolute; background:#207be6;}
	.newsInfoConStar .border_bottom {
		bottom: 0;
		right: 0;
		position: absolute;
		background: #5CB5F4;
	}

	.newsInfoConStar .border_top,
	.newsInfoConStar .border_bottom {
		height: 1px;
		width: 0;
	}

	.newsInfoConStar .border_right,
	.newsInfoConStar .border_left {
		height: 0px;
		width: 1px;
	}

	// .newsInfoConStar .download-detail:hover{border-color: transparent;}
	.newsInfoConStar:hover .border_top,
	.newsInfoConStar:hover .border_bottom {
		width: 100%
	}

	.newsInfoConStar:hover .border_left,
	.newsInfoConStar:hover .border_right {
		height: 100%
	}

	// newsInfo结束**********************
	// ****************修改样式
	.homeDiv /deep/ .el-carousel__container {
		position: relative;
		height: 650px;
	}

	.homeDiv /deep/ .el-carousel {
		overflow: hidden;
	}

	.homeDiv /deep/ .el-carousel__item {
		width: 100%;
		height: 100%;
	}

	.homeDiv /deep/ .el-carousel__item>div {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.homeDiv /deep/ .el-carousel__item>div>div {
		position: absolute;
		left: 8%;
		right: 0;
		// top: 52%;
		top: 20%;
		width: 45%;
		text-shadow: 1px 3px 3px rgba(31, 45, 61, .75);
		// background: #186dc7;
	}

	.homeDiv /deep/ .el-carousel__item>div img {
		width: 100%;
		height: 100%;
	}

	.homeDiv /deep/ .el-carousel__item>div .bt {
		font-size: 44px;
		color: #fff;
	}

	.homeDiv /deep/ .el-carousel__item>div .js {
		color: #fff;
		font-size: 18px;
		margin-top: 20px;
	}

	.homeDiv /deep/ .el-carousel__item>div .more {
		margin-top: 70px;
		display: inline-block;
		color: #fff;
		border: 1px solid rgba(255, 255, 255, 0.2);
		font-size: 16px;
		padding: 14px 68px 14px 14px;
		line-height: 1;
		position: relative;
	}

	.homeDiv /deep/ .el-carousel__item>div .more i {
		position: absolute;
		right: 0;
		top: 0;
		width: 48px;
		height: 100%;
		transition: all 0.4s;
		background: url(../../assets/img/more_jt1.png) right 18px center no-repeat rgba(255, 255, 255, 0.2);
	}

	.homeDiv /deep/ .el-carousel__item>div .more:after {
		width: 9px;
		height: 9px;
		content: "";
		position: absolute;
		top: -9px;
		right: -9px;
		background: rgba(255, 255, 255, 0.12);

	}

	// 修改banner的部分样式
	.homeDiv /deep/ .el-carousel__button {
		width: 32px;
		height: 4.5px;
		border-radius: 2px;
	}

	.homeDiv /deep/ .el-carousel__indicators--horizontal {
		bottom: 6px;
	}

	.homeDiv /deep/ .el-carousel__arrow {
		width: 45px;
		height: 45px;
		font-size: 22px;
		background-color: rgba(31, 45, 61, .3);
	}
</style>